<template>
  <v-data-table
    :items="infoGenero"
    :headers="headers"
    hide-details
    hide-default-footer
    disable-pagination
    :hide-default-headers="!infoGenero.length"
    no-data-text="Não há dados para essa composição de filtros"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td>{{ item['DES_SEXO_CLIENTE'] }}</td>
        <td class="text-right">{{ item['NUM_CLIENTES_CADASTRADOS'] | localeString }}<mf-quick-actions v-if="!isPdf" v-bind="getQuickActionProps(item)" /></td>
        <td v-if="!isPdf" class="text-right">{{ item['PORCENTAGEM'] | abreviation | percent }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { criteriaGroup, personTypeCriteria, genderCriteria } from '@/components/quick-actions/segmentationGroups.js'

export default {
  props: {
    infoGenero: {
      type: Array,
      default: () => [],
    },
    isPdf: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Gênero',
          align: 'left',
          value: 'DES_SEXO_CLIENTE',
        },
        {
          text: 'Quantidade',
          align: 'right',
          value: 'NUM_CLIENTES_CADASTRADOS',
        },
        ...(this.isPdf
          ? []
          : [
              {
                text: '%',
                align: 'right',
                value: 'PORCENTAGEM',
              },
            ]),
      ]
    },
  },
  methods: {
    getQuickActionProps(item) {
      return {
        key: item.gender,
        quickActionGroupId: `gender-${item.gender}`,
        shortDescription: `Clientes do gênero - ${item.DES_SEXO_CLIENTE}`,
        longDescription: `Clientes do gênero - ${item.DES_SEXO_CLIENTE}`,
        segmentationGroup: (quickActionFiltersCriteria) =>
          criteriaGroup([
            personTypeCriteria('F'),
            genderCriteria(item.gender === 'U' ? '<empty>' : item.gender),
            ...quickActionFiltersCriteria.criteria.segments,
            ...quickActionFiltersCriteria.criteria.loyalty,
            ...quickActionFiltersCriteria.criteria.clientGroups,
          ]),
      }
    },
  },
}
</script>
